import React, { useEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';

// Variante B — Hero con identificación de síntomas primero
// Hipótesis: la usuaria que se reconoce en sus síntomas antes
// de ver el producto scrollêl más y convierte más.

const symptoms = ['Dormís. Pero te despertás sin haber descansado.', 'Tu cuerpo cambió aunque no cambió nada en lo que hacés.', 'Hay días en que no te reconocés del todo.'];
export function HeroSectionB() {
  const scrollToOffer = () => {
    document.getElementById('offer')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-gradient-hero min-h-0 flex flex-col items-center pt-16 pb-16 px-5 md:px-8 relative overflow-hidden" data-id="element-180" data-mp="1j4ldq90112iu">
      {/* Vertical decorative lines */}
      <div className="absolute left-[8%] md:left-[20%] top-0 bottom-0 w-px bg-gradient-to-b from-transparent via-gold/10 to-transparent" data-id="element-181" data-mp="2aw14mf8m9bev" />
      <div className="absolute right-[8%] md:right-[20%] top-0 bottom-0 w-px bg-gradient-to-b from-transparent via-gold/10 to-transparent" data-id="element-182" data-mp="2fou8l0w9gfpw" />

      <div className="max-w-xl mx-auto w-full relative z-10 flex flex-col items-center text-center" data-id="element-183" data-mp="feecj3yc7ztn">

        {/* --- BLOQUE 1: SÍNTOMAS --- */}
        {/* Sin eyebrow, sin nombre del producto. La usuaria primero se reconoce. */}
        <div className="w-full mb-16" data-id="element-184" data-mp="pb99hieyps5t">
          {symptoms.map((symptom, i) => <motion.p key={i} initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          delay: i * 0.25
        }} className="font-display text-[22px] md:text-[28px] text-[#F0E8D8] leading-[1.35] mb-6 last:mb-0" data-id="element-185" data-mp="133ff4akhogr0" data-mpi={i}>
              {symptom}
            </motion.p>)}
        </div>

        {/* Divider */}
        <motion.div initial={{
        scaleX: 0,
        opacity: 0
      }} animate={{
        scaleX: 1,
        opacity: 1
      }} transition={{
        duration: 0.8,
        delay: 0.9
      }} className="w-16 h-px bg-gold/40 mb-16" data-id="element-186" data-mp="3esq5xggug9ci" />

        {/* --- BLOQUE 2: SEÑAL --- */}
        {/* La conclusión emocional: el cuerpo no falló, cambió la señal. */}
        <div className="w-full mb-16" data-id="element-187" data-mp="1is7n83sd2ema">
          <motion.p initial={{
          opacity: 0,
          y: 14
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.9,
          delay: 1.1
        }} className="font-display font-semibold text-[40px] md:text-[56px] text-[#F0E8D8] leading-[1.08] tracking-tight" data-id="element-188" data-mp="1mr6w1zh7qvj0">
            Tu cuerpo<br data-id="element-189" data-mp="21neht489s50e" />no falló.
          </motion.p>

          <motion.p initial={{
          opacity: 0,
          y: 14
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.9,
          delay: 1.55
        }} className="font-display italic text-gradient-gold text-[36px] md:text-[50px] leading-[1.1] mt-4" data-id="element-190" data-mp="26fxve16yj057">
            Cambió la señal.
          </motion.p>

          <motion.p initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.8,
          delay: 2.1
        }} className="font-display text-[18px] md:text-[22px] text-[#F0E8D8]/65 mt-6 max-w-md mx-auto leading-[1.5]" data-id="element-191" data-mp="2kfqilmj9yy8f">
            Y nadie te enseñó a leerla.
          </motion.p>
        </div>

        {/* --- BLOQUE 3: PRODUCTO --- */}
        {/* Recién acá aparece H.E.R. Después del contexto emocional, */}
        {/* el producto se percibe como la respuesta, no como una oferta. */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 2.5
      }} className="w-full mb-10" data-id="element-192" data-mp="38aaf8rcv7gua">
          <p className="uppercase tracking-[0.28em] text-[11px] text-[#C8A870] font-semibold mb-6" data-id="element-193" data-mp="2zhfikm1gqtg4">
            Protocolo H·E·R
          </p>

          {/* Imagen del producto */}
          <div className="relative mx-auto w-fit mb-8" data-id="element-194" data-mp="3r94rntouw57a">
            <div className="absolute inset-0 -z-10 flex items-center justify-center pointer-events-none" data-id="element-195" data-mp="3r7jz29m3qwc2">
              <div className="w-[70%] h-[70%] rounded-full bg-gold/8 blur-[70px]" data-id="element-196" data-mp="3btzruojngsh9" />
            </div>
            <img src="https://cdn.shopify.com/s/files/1/0730/1614/8145/files/ebook_430x.webp?v=1780543244" alt="Sistema Completo H.E.R." width={280} height={375} loading="eager" fetchPriority="high" decoding="async" className="w-[280px] max-w-[85vw] block rounded-[4px] shadow-[0_25px_60px_rgba(0,0,0,0.5)] mx-auto" data-id="element-197" data-mp="3godfu5vzfxbw" />
          </div>

          {/* Descripción breve del producto */}
          <p className="font-display italic text-[#F0E8D8] text-[22px] md:text-[26px] leading-[1.4] max-w-sm mx-auto" data-id="element-198" data-mp="3b21avp69r1m">
            21 días para reorganizar lo que tu cuerpo necesita en esta etapa.
          </p>

          <p className="font-body text-[14px] text-[#F0E8D8]/50 mt-3 tracking-wide" data-id="element-199" data-mp="3pp1tgzhgrvo9">
            Balance hormonal · Energía · Ritmo
          </p>
        </motion.div>

        {/* --- CTA --- */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        delay: 3
      }} className="flex flex-col items-center w-full max-w-md space-y-4" data-id="element-200" data-mp="m4fmwa6zwl4k">
          <CTAButton section="hero" onClick={scrollToOffer} data-id="element-201" data-mp="2ghi395i5uw0i">
            Ver el protocolo completo
          </CTAButton>

          <p className="uppercase tracking-[0.14em] text-[11px] text-[#C8A870] text-center font-body" data-id="element-202" data-mp="2bjylvwq6234c">
            ✦ Acceso inmediato ✦ Garantía 30 días ✦ 3 cuotas de $4.000
          </p>
        </motion.div>

      </div>
    </section>;
}